import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BannerResponseDTO } from 'src/app/shared/models/dtos/responses/banner-response-dto/banner-response-dto';

@Component({
  selector: 'app-notice-modal',
  templateUrl: './notice-modal.component.html',
  styleUrls: ['./notice-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Notice modal component
 */
export class NoticeModalComponent implements OnInit {
  /**
   * Constructor
   */
  constructor(
    public dialogRef: MatDialogRef<NoticeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BannerResponseDTO,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {}
  title!: string;
  body!: SafeHtml;
  button?: { title: string; href: string };

  /**
   * Init
   */
  /* eslint-disable */
  ngOnInit() {
    this.title = this.data.title;
    this.body = this.sanitizer.bypassSecurityTrustHtml(this.data.description);
    this.button = {
      title: this.data.buttonName,
      href: this.data.url,
    };
  }
  // Remove this
  /* eslint-enable */

  /**
   * Action to close the dialog
   */
  onCloseClick() {
    this.dialogRef.close();
  }

  /**
   * Redirects by url stored in button
   * @param {string} url
   */
  redirect(url: string) {
    const route = url.split('/')[3];
    this.router.navigate([route]);
    this.onCloseClick();
  }
}
